import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RegistrationData } from '../../pages/RegisterPage';

interface ClientDetailsStepProps {
  data: RegistrationData;
  onDataChange: (data: Partial<RegistrationData>) => void;
  onNext: () => void;
  onBack: () => void;
}

const ClientDetailsStep: React.FC<ClientDetailsStepProps> = ({
  data,
  onDataChange,
  onNext,
  onBack,
}) => {
  const { t } = useTranslation();
  const handleChange = (field: keyof RegistrationData) => (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | any
  ) => {
    onDataChange({ [field]: event.target.value });
  };

  const canProceed = data.companyName;

  return (
    <Box>
      <Typography
        variant="h5"
        sx={{
          textAlign: 'center',
          mb: 4,
          fontWeight: 600,
          color: '#ffffff',
        }}
      >
        {t('auth.register.clientDetails.title')}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          textAlign: 'center',
          mb: 4,
          color: '#a0a0a0',
          maxWidth: 600,
          mx: 'auto',
        }}
      >
        {t('auth.register.clientDetails.subtitle')}
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('auth.register.clientDetails.companyName')}
            value={data.companyName || ''}
            onChange={handleChange('companyName')}
            required
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                '& fieldset': {
                  borderColor: '#2d2d44',
                },
                '&:hover fieldset': {
                  borderColor: '#28A0F0',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#28A0F0',
                },
              },
              '& .MuiInputLabel-root': {
                color: '#a0a0a0',
              },
              '& .MuiInputBase-input': {
                color: '#ffffff',
              },
            }}
          />
        </Grid>


      </Grid>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
        <Button
          variant="outlined"
          onClick={onBack}
          sx={{
            borderColor: '#2d2d44',
            color: '#ffffff',
            px: 4,
            py: 1.5,
            '&:hover': {
              borderColor: '#28A0F0',
              backgroundColor: 'rgba(40, 160, 240, 0.1)',
            },
          }}
        >
          {t('auth.register.clientDetails.back')}
        </Button>

        <Button
          variant="contained"
          onClick={onNext}
          disabled={!canProceed}
          sx={{
            background: 'linear-gradient(135deg, #28A0F0 0%, #ec4899 100%)',
            px: 6,
            py: 1.5,
            '&:hover': {
              background: 'linear-gradient(135deg, #1d4ed8 0%, #be185d 100%)',
            },
            '&:disabled': {
              background: '#2d2d44',
              color: '#6b7280',
            },
          }}
        >
          {t('auth.register.clientDetails.next')}
        </Button>
      </Box>
    </Box>
  );
};

export default ClientDetailsStep;
